export default __webpack_public_path__ + "media/header2x.79feb264.png";